import constants from "../config/constants";

export default {
  watch: {
    zones: function () {
      this.getZonesTemperature();
    },
  },

  computed: {
    zones: function () {
      let zones = [];

      function getZones(zone) {
        if (
          zone.zones === undefined &&
          zone.type === constants.zoneTypes.radiator
        ) {
          zones.push({
            name: zone.name,
            temp: zone.temp,
            id: zone.path.split("/")[zone.path.split("/").length - 1],
            path: zone.path,
            devices: zone.devices !== undefined ? zone.devices : {},
          });
        }

        if (zone.zones !== undefined)
          Object.values(zone.zones).forEach((z) => getZones(z));
      }

      //DEFINE ZONE FIREBASE NODE TO WATCH DEPENDING ON COMPONENT NAME
      let zonesNode =
        this.$options.name === "installation-thermostat"
          ? this.installation.zones
          : this.zone.zones;

      if (zonesNode) {
        Object.values(zonesNode).forEach((zone) => {
          getZones(zone);
        });
      }

      return zones;
    },
  },

  methods: {
    getZonesTemperature: function () {
      this.temperature =
        this.zones.every((val, i, arr) => val.temp === arr[0].temp) &&
        this.zones.length > 0
          ? this.zones[0].temp
          : this.zone
          ? this.zone.temp
          : null;
    },
  },

  mounted() {
    this.getZonesTemperature();
  },
};
